import React, { useState, useEffect } from 'react';
import { LossReason } from '../../../../types';
import { Button } from '../../../../components/ui/Button';
import Input from '../../../../components/ui/Input';
import Modal from '../../../../components/ui/Modal';

interface LossReasonFormModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (data: Omit<LossReason, 'id' | 'createdAt'>) => Promise<void>;
    reasonToEdit?: LossReason;
}

const LossReasonFormModal: React.FC<LossReasonFormModalProps> = ({ isOpen, onClose, onSave, reasonToEdit }) => {
    const [name, setName] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setName(reasonToEdit?.name ?? '');
        }
    }, [isOpen, reasonToEdit]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            await onSave({ name });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <Modal.Header onClose={onClose}>
                {reasonToEdit ? 'Editar Motivo de Perda' : 'Novo Motivo de Perda'}
            </Modal.Header>
            <Modal.Body>
                <form id="reason-form" onSubmit={handleSubmit}>
                    <Input
                        label="Nome"
                        name="name"
                        type="text"
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Ex: Preço alto"
                        autoFocus
                    />
                </form>
            </Modal.Body>
            <Modal.Footer className="flex-col-reverse gap-2 sm:flex-row">
                <Button variant="secondary" onClick={onClose} className="w-full sm:w-auto" disabled={isSaving}>
                    Cancelar
                </Button>
                <Button type="submit" form="reason-form" className="w-full sm:w-auto" disabled={isSaving}>
                    {isSaving ? 'Salvando...' : 'Salvar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LossReasonFormModal;
